import type { SVGProps } from 'react';
import * as React from 'react';

const AdjustmentsHorizontalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/adjustments-horizontal">
      <g id="Icon">
        <path
          d="M12 4.49998C12 3.17449 10.9255 2.09998 9.60002 2.09998C8.27454 2.09998 7.20002 3.17449 7.20002 4.49998C7.20002 5.82546 8.27454 6.89998 9.60002 6.89998C10.9255 6.89998 12 5.82546 12 4.49998Z"
          fill="currentColor"
        />
        <path
          d="M20.7 5.39998C21.1971 5.39998 21.6 4.99703 21.6 4.49998C21.6 4.00292 21.1971 3.59998 20.7 3.59998L14.1 3.59998C13.603 3.59998 13.2 4.00292 13.2 4.49998C13.2 4.99703 13.603 5.39998 14.1 5.39998L20.7 5.39998Z"
          fill="currentColor"
        />
        <path
          d="M6.00002 4.49998C6.00002 4.99703 5.59708 5.39998 5.10002 5.39998H3.30002C2.80297 5.39998 2.40002 4.99703 2.40002 4.49998C2.40002 4.00292 2.80297 3.59998 3.30002 3.59998L5.10002 3.59998C5.59708 3.59998 6.00002 4.00292 6.00002 4.49998Z"
          fill="currentColor"
        />
        <path
          d="M5.10002 20.4C5.59708 20.4 6.00002 19.997 6.00002 19.5C6.00002 19.0029 5.59708 18.6 5.10002 18.6H3.30002C2.80297 18.6 2.40002 19.0029 2.40002 19.5C2.40002 19.997 2.80297 20.4 3.30002 20.4H5.10002Z"
          fill="currentColor"
        />
        <path
          d="M20.7 20.4C21.1971 20.4 21.6 19.997 21.6 19.5C21.6 19.0029 21.1971 18.6 20.7 18.6H14.1C13.603 18.6 13.2 19.0029 13.2 19.5C13.2 19.997 13.603 20.4 14.1 20.4H20.7Z"
          fill="currentColor"
        />
        <path
          d="M10.8 12C10.8 12.497 10.3971 12.9 9.90002 12.9H3.30002C2.80297 12.9 2.40002 12.497 2.40002 12C2.40002 11.5029 2.80297 11.1 3.30002 11.1H9.90002C10.3971 11.1 10.8 11.5029 10.8 12Z"
          fill="currentColor"
        />
        <path
          d="M20.7 12.9C21.1971 12.9 21.6 12.497 21.6 12C21.6 11.5029 21.1971 11.1 20.7 11.1H18.9C18.403 11.1 18 11.5029 18 12C18 12.497 18.403 12.9 18.9 12.9H20.7Z"
          fill="currentColor"
        />
        <path
          d="M16.8 12C16.8 10.6745 15.7255 9.59998 14.4 9.59998C13.0745 9.59998 12 10.6745 12 12C12 13.3255 13.0745 14.4 14.4 14.4C15.7255 14.4 16.8 13.3255 16.8 12Z"
          fill="currentColor"
        />
        <path
          d="M12 19.5C12 18.1745 10.9255 17.1 9.60002 17.1C8.27454 17.1 7.20002 18.1745 7.20002 19.5C7.20002 20.8255 8.27454 21.9 9.60002 21.9C10.9255 21.9 12 20.8255 12 19.5Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default AdjustmentsHorizontalIcon;
